import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/$org/integrations/")({
  beforeLoad: ({ params }) => {
    throw redirect({ href: `/${encodeURIComponent(params.org)}/integrations/mcp` });
  },
});
